<template>
    <div class="back-container">
        <div class="back-container__warning">
            <slot name="warning"/>
        </div>
        <div class="action-buttons">
            <slot name="buttons"/>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';

    export default Vue.component('BackContainer', {});
</script>



// WEBPACK FOOTER //
// src/app/modules/shared/components/BackContainer.vue